import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { GuiaForm } from "./form";
import { observeResource } from "kea-resource";
const GuiaFormRx = componentToRx(GuiaForm);
type Entity = models.Guia;
const resource = resources.Guia;

interface Props {
    match: match<{ id: string }>
}

const permisos = resources.User.PermisoRx;
const session = resources.User.SessionRx;
class GuiaEditComp extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }
    private id = (props: Props) => props.match.params.id;
    private value = createSelectorRx(this.id, id => observeResource(resource.Get, id));

    render() {
        const props = this.props;
        const value = this.value(props);
        return <GuiaFormRx value={value} permisos={permisos} session={session} />;
    }
}

export const GuiaEdit = withRouter(GuiaEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/edit.tsx